import './styles/ClientRetrievalScanAWBStyle.css';
import './styles/CommonStyles.css';
import React, { useCallback, useEffect, useState } from 'react';
import {
  ControlledNumericInput,
  NumPad,
  NavigationButton,
  TopNav,
  TopNavToastMessage,
  ToastType,
} from '../common';
import { languageMap } from '../../maps/languageMap';
import { useActions, useTypedSelector } from '../../hooks';
import { APIResponseStatusType, navigationPages } from '../../models/types';
import { useHistory } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import ScanCode from '../../resources/images/scanCode.png';
import { apiErrorHandler, apiGET, apiPOST } from '../../restApi';
import {
  LockerContentRequestGET,
  LockerContentResponseGET,
  ExitValidationRequestPOST,
  ExitValidationResponsePOST,
} from '../../models/cruds';
import { BsFillPersonFill } from 'react-icons/bs';

const AWB_VALID_LENGTH = 10;
const AWB_FEEDBACK_NON_EXISTING_PIECE = 'Tu envío no se encuentra en locker';
const AWB_FEEDBACK_LENGTH = 'El número de guía es de 10 caractéres';
const VALIDATION_ERROR = 'Error en la consulta';

const ClientRetrievalScanAWB: React.FC = () => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [awbNumber, setAwbNumber] = useState('');
  const [variableInError, setVariableInError] = useState('');
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const token = useTypedSelector(({ session }) => {
    return session.dhlApiToken;
  });
  const agentToken = useTypedSelector(({ session }) => {
    return session.dhlAgentToken;
  });
  const isAgentProcess = useTypedSelector(({ locker }) => {
    return locker.isAgentProcess;
  });
  const isMultiDelivery = useTypedSelector(({ locker }) => {
    return locker.isMultiDelivery;
  });
  const customerName = useTypedSelector(({ locker }) => {
    return locker.customerName;
  });
  const scanner = useTypedSelector(({ devices }) => {
    return devices.scanner;
  });
  const {
    sessionUpdateDHLTokenExpired,
    updateLockerContent,
    updateCurrentLockerPosition,
    lockerReset,
  } = useActions();
  useEffect(() => {
    if (scanner) {
      scanner?.pullTriggerAsync().catch((error) => console.error(error));
    }
    let timer = setInterval(() => {
      if (scanner) {
        scanner?.pullTriggerAsync().catch((error) => console.error(error));
      }
    }, 4000);
    return () => clearTimeout(timer);
  }, [scanner]);
  useEffect(() => {
    if (scanner) {
      scanner?.pullTriggerAsync().catch((error) => console.error(error));
    }
    let timer = setInterval(() => {
      if (scanner) {
        scanner?.pullTriggerAsync().catch((error) => console.error(error));
      }
    }, 4000);
    return () => clearTimeout(timer);
  }, [scanner]);
  const onScan = useCallback(
    (event: CustomEvent) => {
      console.log(event);
      if (!loading && event.detail) {
        let filteredScan = event.detail.replace('\n', '');
        filteredScan = filteredScan.replace('\r', '');
        if (filteredScan.length === AWB_VALID_LENGTH) {
          setAwbNumber(filteredScan);
        }
        let timer = setTimeout(() => {
          scanner?.pullTriggerAsync().catch((error) => console.error(error));
        }, 2000);
        return () => clearTimeout(timer);
      }
    },
    [loading, scanner]
  );
  useEffect(() => {
    const addScannerEventListeners = () => {
      scanner?.addEventListener('scan', onScan as EventListener);
    };
    addScannerEventListeners();
  }, [scanner, onScan]);
  useEffect(
    () => () => {
      const removeScannerEventListeners = () => {
        scanner?.removeEventListener('scan', onScan as EventListener);
      };
      removeScannerEventListeners();
    },
    [scanner, onScan]
  );
  useEffect(() => {
    if (!loading && awbNumber !== '' && awbNumber.length === AWB_VALID_LENGTH) {
      requestAWBValidation();
    }
  }, [loading, awbNumber]);
  const isAwbInLocker = async (): Promise<boolean> => {
    let request = new LockerContentRequestGET();
    let response: LockerContentResponseGET = await apiGET(
      request.buildURL(),
      request.generateConfig(token)
    );
    let errorMsg = '';
    try {
      if (response.status === APIResponseStatusType.SUCCESS) {
        if (response.data.lockerRack) {
          let content = response.data.lockerRack;
          let positionWithAWB = content.lockerPositions.find(
            (position) => position.packageCandidate?.awbNumber === awbNumber
          );
          if (positionWithAWB) {
            updateCurrentLockerPosition(positionWithAWB);
            updateLockerContent(content.lockerPositions);
            return true;
          } else {
            setFeedbackMessage(AWB_FEEDBACK_NON_EXISTING_PIECE);
            return false;
          }
        }
      } else {
        errorMsg = apiErrorHandler(response);
        if (errorMsg === APIResponseStatusType.UNAUTHORIZED) {
          sessionUpdateDHLTokenExpired(true);
          return false;
        }
      }
    } catch (err: any) {
      errorMsg = err.toString();
    }
    console.log(errorMsg);
    setFeedbackMessage(VALIDATION_ERROR);
    return false;
  };
  const validateCode = async (): Promise<boolean> => {
    let request = new ExitValidationRequestPOST();
    let response: ExitValidationResponsePOST = await apiPOST(
      request.buildURL(),
      request.generateContent(awbNumber, '', ''),
      request.generateConfig(agentToken)
    );
    let errorMsg = '';
    try {
      if (response.status === APIResponseStatusType.SUCCESS) {
        if (response.data.exitValidation) {
          let content = response.data.exitValidation;
          let positionWithAWB = content.packageCandidate.awbNumber;
          if (positionWithAWB === awbNumber) {
            return true;
          }
        } else {
          //TODO check for unauth and refresh token
          errorMsg = 'Unauthorized';
        }
      } else {
        errorMsg = apiErrorHandler(response);
      }
    } catch (err: any) {
      errorMsg = err.toString();
    }
    console.log(errorMsg);
    setFeedbackMessage(VALIDATION_ERROR);
    return false;
  };
  const requestAWBValidation = async () => {
    if (awbNumber.length < AWB_VALID_LENGTH) {
      setFeedbackMessage(AWB_FEEDBACK_LENGTH);
      return;
    }
    setLoading(true);
    if (await isAwbInLocker()) {
      console.log('Is agent: ', isAgentProcess, isMultiDelivery);

      if (isAgentProcess) {
        if (await validateCode()) {
          if (isMultiDelivery) {
            history.replace(`/${navigationPages.CLIENT_RETRIEVAL_PIECE}`);
          } else {
            history.replace(`/${navigationPages.CLIENT_RETRIEVAL_NAME}`);
          }
        }
      } else {
        history.replace(
          `/${navigationPages.CLIENT_RETRIEVAL_VERIFICATION_CODE}`
        );
      }
    }
    setAwbNumber('');
    setLoading(false);
  };
  const handleKeypress = (e: any) => {
    //it triggers by pressing the enter key
    if (e.key === 'Enter') {
      requestAWBValidation();
    }
  };
  const handleNumPad = (option: string) => {
    setFeedbackMessage('');
    //it triggers by pressing the enter key
    if (option === 'go') {
      requestAWBValidation();
      return;
    }
    if (option === 'back') {
      setAwbNumber(awbNumber.slice(0, -1));
      return;
    }
    if (awbNumber.length < AWB_VALID_LENGTH) {
      setAwbNumber(awbNumber + option);
    } else {
      setFeedbackMessage(AWB_FEEDBACK_LENGTH);
    }
  };
  const handleBackButton = () => {
    if (isAgentProcess) {
      history.replace(`/${navigationPages.AGENT_PROCESS_SELECTION}`);
    } else {
      history.replace(`/${navigationPages.LANDING}`);
    }
  };
  const renderNumpad = () => {
    if (loading) {
      return (
        <div className="client-retrieval-scan-numpad-container">
          <div className="spinner-container">
            <Spinner className="spinner" animation="grow" variant="danger" />
          </div>
        </div>
      );
    }
    return (
      <div className="client-retrieval-scan-numpad-container">
        <NumPad
          onClickButton={(option) => {
            handleNumPad(option);
          }}
        />
      </div>
    );
  };
  const renderContent = () => {
    return (
      <div className="locker-content-container">
        <div className="locker-content-container-left">
          <div className="client-retrieval-scan-awb-container">
            <ControlledNumericInput
              val={awbNumber}
              inputLabel="Número de Guía"
              inputPlaceholder="12 34546 7895"
              validationError={variableInError === 'awbNumber'}
              maxLength={10}
              maxNumber={9999999999}
              disabled={loading}
              type="integer"
              onError={(isErr: boolean) => {
                if (isErr) {
                  let msg = languageMap.login.installation_id_error[language];
                  setVariableInError('awbNumber');
                  setFeedbackMessage(msg);
                } else {
                  setFeedbackMessage('');
                  setVariableInError('');
                }
              }}
              onTextChange={(newVal: string) => {
                setVariableInError('');
                setFeedbackMessage('');
                setAwbNumber(newVal);
              }}
              handleKeypress={handleKeypress}
              extraClassContainer="no-padding-right full-width stretched"
              extraClass="placeholder-left"
            />

            <div className="scan-awb-image-awb-container">
              <img
                id="awb-image"
                className="awb-image"
                src={ScanCode}
                alt="QR"
              />
            </div>
          </div>
        </div>
        <div className="locker-content-container-right">{renderNumpad()}</div>
      </div>
    );
  };
  const renderButtonContent = () => {
    return (
      <div className="not-me-button-content">
        <BsFillPersonFill className="not-me-button-icon" />
        {languageMap.client_retrieval_scan_awb.not_me[language]}
      </div>
    );
  };
  const renderCustomerInfo = () => {
    if (customerName !== '') {
      return (
        <p className="subtitle nopadding horizontal pascal nomargin">
          {customerName.toLocaleLowerCase()}
          <NavigationButton
            buttonContent={renderButtonContent()}
            buttonClass="default-button not-me-button"
            onClickButton={() => {
              lockerReset();
              history.replace(`/${navigationPages.CLIENT_RETRIEVAL_SCAN_AWB}`);
            }}
          />
        </p>
      );
    }
  };
  return (
    <div id="clientRetrievalScanAWB" className="main-container">
      <TopNav
        dataCyPrefix="scan-awb"
        logoNavigation={() => {
          history.replace(`/${navigationPages.AGENT_AUTH_EMPLOYEE_NUMBER}`);
        }}
      />
      <div className="content-container">
        <div className="main-content-container fullpage">
          <TopNavToastMessage
            toastText={feedbackMessage}
            toastType={ToastType.ERROR}
            resetMessage={() => setFeedbackMessage('')}
          />
          <div className="title-content-container vertical">
            <p className="header nopadding nomargin">
              {languageMap.client_retrieval_scan_awb.title[language]}
            </p>

            {renderCustomerInfo()}
          </div>
          <div className="data-content-container">{renderContent()}</div>
          <div className="footer-container">
            <div className="footer-button-container">
              <NavigationButton
                buttonContent={
                  languageMap.client_retrieval_scan_awb.back_button[language]
                }
                buttonClass="navigation-button cancel-button complete"
                onClickButton={() => {
                  handleBackButton();
                }}
              />
            </div>
            <div className="footer-button-container" />
          </div>
        </div>
      </div>
    </div>
  );
};

export { ClientRetrievalScanAWB };
